import React from 'react';
import { BOLD_KEY } from '@techchange/pm-specs';
import PropTypes from 'prop-types';
import { EditorView } from 'prosemirror-view';
import { useIntl } from 'react-intl';

import { messages } from '../../../../../../_shared/i18n/messages';

import { ToolbarButton } from '../../../Toolbar';
import isMarkActive from '../../utils/isMarkActive';
import { toggleStrong } from '../commands';

const propTypes = {

	/**
	 * The id of the DOM element where the editor will be injected.
	 */
	editorDomId: PropTypes.string.isRequired,

	/*
	 * The prosemirror editor view object.
	 */
	editorView: PropTypes.instanceOf(EditorView).isRequired,

	/**
	 * The provided toolbar props to adhere to accessibility (a11y)
	 * guidelines for button toolbars.
	 *
	 * See here: https://www.w3.org/WAI/ARIA/apg/patterns/toolbar
	 */
	a11yToolbarProps: PropTypes.shape({

		/**
		 * The tab index value for the button. Only the button with
		 * current focus should have tab index value of 0. All others
		 * should have value of -1.
		 */
		tabIndex: PropTypes.oneOf(['0', '-1']).isRequired,

		/**
		 * Callback function to handle keypress events on the button.
		 */
		onKeyDown: PropTypes.func.isRequired,

	}),

};

const BoldButton = (props) => {

	const {
		editorDomId,
		editorView,
		a11yToolbarProps = {},
	} = props;

	const intl = useIntl();

	const boldMarkType = editorView.state.schema.marks[BOLD_KEY];

	const active = isMarkActive(boldMarkType, editorView.state);

	const handleOnToggle = () => {

		toggleStrong(editorView.state, editorView.dispatch);
		editorView.focus();

	};

	return (
		<ToolbarButton
			id={`${editorDomId}-toolbar-btn-bold`}
			icon="fas fa-bold"
			active={active}
			disabled={false}
			title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_BOLD_BUTTON_TITLE)}
			onClick={handleOnToggle}
			{...a11yToolbarProps} />
	);

};

BoldButton.propTypes = propTypes;

export default BoldButton;
